import React from 'react';
import { FormattedMessage } from 'react-intl';

// components
import { Spinner } from 'dibs-elements/exports/Spinner';

// styles
import styles from './styles/FeedLoader.scss';

export const FeedLoader = () => {
    return (
        <div className={styles.container}>
            <div className={styles.spinner}>
                <Spinner />
            </div>
            <div className={styles.text}>
                <FormattedMessage
                    id="discover.feedLoader.loading"
                    defaultMessage="Preparing your feed"
                />
            </div>
        </div>
    );
};
